import React from 'react'
import { HellFire } from './components/hell-fire'
import { Devil } from './components/devil'
import { Snakes } from './components/snakes'
import { MenuPanel } from './components/menu-panel'
import { Bats } from './components/bats'
import { DrawArea } from './components/draw-area'
import html2canvas from 'html2canvas'
import SlayannePng from './assets/slayanne-01.png'

import './styles.scss'

const saveScreenshot = () => {
  if (
    !confirm(
      'The 🔥DARK LORD🔥 demands that you 📷 take a picture 🖼️ or give up your soul to the 🔥fiery🔥 flames of 𖤐 gay 𖤐 hell! 🌈'
    )
  )
    return

  const app = document.getElementById('app')
  html2canvas(app, {
    //allowTaint: true,
    imageTimeout: 0,
    //foreignObjectRendering: true,
    backgroundColor: '#00000'
  }).then(function(canvas) {
    document.body.appendChild(canvas)
    let pngUrl = canvas.toDataURL()
    document.body.removeChild(canvas)
    var link = document.createElement('a')
    document.body.appendChild(link)
    link.setAttribute('href', pngUrl)
    link.setAttribute('download', 'slayanne-drawing.png')
    link.click()

    setTimeout(() => {
      document.body.removeChild(link)
    }, 1000)
  })
}

export default () => {
  return (
    <div className="bg-primary flex-grow-1 d-flex flex-column justify-content-start align-items-center home-container">
      <div className="logo-container text-right mr-5 d-inline align-self-end">
        <a
          className="logo-link"
          href="/"
          onClick={e => {
            e.preventDefault()
            saveScreenshot()
          }}
        >
          <img
            src={SlayannePng}
            alt="Slayanne"
            className="logo"
            width="175px"
          />
        </a>
      </div>
      <iframe
        width="0"
        height="0"
        scrolling="no"
        frameBorder="no"
        allow="autoplay"
        src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/968830348&color=%23ff5500&auto_play=true&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"
      />
      <Devil />
      <MenuPanel />
      <HellFire />
      <Snakes />
      <Bats />
      <img
        src="https://counter2.stat.ovh/private/freecounterstat.php?c=aa8b4hfxnucys36d8a9r5ntext2tw7qg"
        border="0"
        title="hit counter"
        alt="hit counter"
        className="stats-counter"
      />
      <DrawArea />
    </div>
  )
}
